module.exports = __webpack_public_path__ + "img/weddings_35_H.8bc0d18a.webp";